<template>
  <div class="classesCircle">
    <div class="bbs-box">
      <!-- 版块 -->
      <div class="community-block">
        <!-- <BlockTags :blockTags="blocks" @checkClick="checkClick"></BlockTags>
         -->
        <el-tabs class="el-tabs-class" v-model="plate_id">
          <el-tab-pane
            :label="item.name"
            :name="String(item.id)"
            v-for="item in blocks"
            :key="item.id"
          ></el-tab-pane>
        </el-tabs>
        <div class="switch-wrap">
          <span class="label">只看我的</span>
          <el-switch
            v-model="slefPublish"
            :active-value="1"
            :inactive-value="2"
            @change="onSwitchChange"
          ></el-switch>
          <SelectItem
            :items="selectItems"
            @handleClick="handleClick"
          ></SelectItem>
        </div>
      </div>
      <ul class="forum-list">
        <CommunityCircleItem
          @complaint="onComplaint"
          :group_id="group_id"
          :plate_id="String(plate_id)"
          :activeTab="activeTab"
          :onlyMyself="onlyMyself"
        ></CommunityCircleItem>
      </ul>
      <Complaint ref="complaint"></Complaint>
    </div>
  </div>
</template>
<script>
import CommunityCircleItem from "@/components/community/components/CommunityCircleItem";
import SelectItem from "@/components/community/components/SelectItem";
import Complaint from "@/components/community/components/Complaint.vue";

export default {
  name: "MemberClassesCircle",
  components: { CommunityCircleItem, SelectItem, Complaint },
  props: {
    group_id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      blocks: [], //版块
      plate_id: "all", //当前版块id
      selectItems: [
        { key: "hot", title: "最热" },
        { key: "new", title: "最新" },
      ],
      activeTab: "hot", //默认最热
      onlyMyself: false, //只看我发布的
      slefPublish: 2,
      totalPage: 0, //数据总数
      page: 1, //当前分页
      limit: 10, //分页限制
    };
  },
  created() {},
  mounted() {
    //获取版块列表
    this.$http.get("/api/app/community/plate").then(res => {
      this.blocks = res || [];
      this.blocks.unshift({ id: "all", name: "全部" });
    });
  },
  methods: {
    // 热门最新话题切换
    async handleClick(data) {
      this.activeTab = data;
    },
    onSwitchChange(val) {
      if (val === 1) {
        this.onlyMyself = true;
      } else {
        this.onlyMyself = false;
      }
    },
    onComplaint(item) {
      this.$refs.complaint.show(5, item.id);
    },
  },
};
</script>
<style lang="scss" scoped>
.classesCircle {
  .bbs-box {
    background-color: #fff;
    overflow: hidden;
    .forum-list {
      padding: 0 24px;
      box-sizing: border-box;
      margin-top: -5px;
    }
    .community-block {
      padding-left: 24px;
      position: relative;
      top: 10px;
      .switch-wrap {
        position: absolute;
        top: 22.5px;
        right: 24px;
        transform: translateY(-50%);
        display: flex;
        align-items: center;
        background: #fff;
        padding-left: 80px;
        .el-switch {
          margin: 0 22px 0 10px;
        }
      }
    }
  }
}
</style>
